export enum AmbassadorDirection {
  Other = '1',
  Nutritionist = '2',
  Doctor = '3',
  HealthCoach = '4',
  Blogger = '5',
  Cosmetologist = '6',
  FitnessTrainer = '7'
}

const { Blogger, Cosmetologist, Doctor, FitnessTrainer, HealthCoach, Nutritionist, Other } = AmbassadorDirection

const nameMapping = new Map([
  [Blogger, 'Блогер'],
  [Cosmetologist, 'Косметолог'],
  [Doctor, 'Врач'],
  [FitnessTrainer, 'Фитнес-тренер'],
  [HealthCoach, 'Health-coach'],
  [Nutritionist, 'Нутрициолог'],
  [Other, 'Другое']
])

export const AmbassadorDirectionUtils = {
  sortedMembers: [Nutritionist, Doctor, HealthCoach, Blogger, Cosmetologist, FitnessTrainer, Other],
  getName: (x: AmbassadorDirection): string => nameMapping.get(x)!
}
